import React, { Component, PureComponent, Fragment } from 'react'
import DateTimePicker from 'react-datetime-picker'

export default function DateTime({ name, value, onChange }) {
  return (
    <div className="form-field-datetime">
      <DateTimePicker
        value={value ? new Date(value) : undefined}
        name={name}
        locale="fi-FI"
        onChange={value => onChange({ name, value: value ? value.toString() : null })}
      />
    </div>
  )
}
